import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () =>
      import('./pages/home/home.module').then((m) => m.HomePageModule),
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  // {
  //   path: 'w',
  //   loadChildren: () => import('./pages/w/w.module').then( m => m.WPageModule)
  // },
  // {
  //   path: 'recover',
  //   loadChildren: () => import('./pages/recover/recover.module').then( m => m.RecoverPageModule)
  // },
  {
    path: 'admin',
    loadChildren: () =>
      import('./pages/admin/admin.module').then((m) => m.AdminPageModule),
  },
  {
    path: 'terms',
    loadChildren: () =>
      import('./pages/terms/terms.module').then((m) => m.TermsPageModule),
  },
  {
    path: 'cookies',
    loadChildren: () =>
      import('./pages/cookies/cookies.module').then((m) => m.CookiesPageModule),
  },
  {
    path: 'privacy',
    loadChildren: () =>
      import('./pages/privacy/privacy.module').then((m) => m.PrivacyPageModule),
  },
  // {
  //   path: 'leadership',
  //   loadChildren: () => import('./pages/leadership/leadership.module').then( m => m.LeadershipPageModule)
  // },
  // {
  //   path: 'director',
  //   loadChildren: () => import('./pages/director/director.module').then( m => m.DirectorPageModule)
  // },
  // {
  //   path: 'reactions',
  //   loadChildren: () => import('./components/idea-reactions-button/reactions/reactions.module').then( m => m.ReactionsPageModule)
  // },
  // {
  //   path: 'modal-reactions',
  //   loadChildren: () => import('./components/idea-reactions-button/modal-reactions/modal-reactions.module').then( m => m.ModalReactionsPageModule)
  // }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
